/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import './Groups.less';
import {
  CloseIcon,
  AccountIcon,
  BadgeIcon,
  NewHC200Icon,
  UnassignedHS200DeviceIcon,
} from '../Common/Icons';
import { useSelector } from 'react-redux';
import { Spin, Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { getUserInfo, getProfilePics } from '@vantiva-sa/homesight_humaui/Store/dataStore';
import { getProfilePicUrl } from '@vantiva-sa/homesight_humaui/Utilities/CommonUtilities';
import { PhotoResolution } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';

const showDevice = (hub) => {
  return hub?.userInfo?.deviceuuid || hub?.userInfo?.deviceuuid === null;
};

const GroupMember = ({
  setShowRemoveMemberConfirmModal,
  record,
  loading,
  setRemoveMemberUuid,
  setRemoveMemberName,
  setupBanner,
  isStaffAdmin,
}) => {
  const trans = useSelector(translator);
  const resourcesMap = useSelector(getProfilePics());

  const invitedUsers = useSelector((state) => {
    return (
      record?.invited_contacts
        ?.map((contact) => {
          const userInfo = getUserInfo(contact.useruuid)(state);
          return {
            useruuid: contact.useruuid,
            userInfo: userInfo,
          };
        })
        .filter((item) => item.userInfo) || []
    );
  });

  function sortUsersByFirstName(users) {
    return users.slice().sort((a, b) => {
      const nameA = a.userInfo && a.userInfo.firstname ? a.userInfo.firstname.toLowerCase() : '';
      const nameB = b.userInfo && b.userInfo.firstname ? b.userInfo.firstname.toLowerCase() : '';
      if (nameA < nameB) return 1;
      if (nameA > nameB) return -1;
      return 0;
    });
  }

  const staffUsers = invitedUsers.filter((user) => user?.userInfo?.deviceuuid === undefined);
  const accountUsers = invitedUsers.filter(
    (user) => user.userInfo.deviceuuid || user.userInfo.deviceuuid === null
  );

  const sortedStaffUsers = sortUsersByFirstName(staffUsers);
  const sortedAccountUsers = sortUsersByFirstName(accountUsers);

  const renderUserCard = (userItem) => {
    const { userInfo } = userItem;
    const profileImageUrl = getProfilePicUrl(userItem.useruuid, resourcesMap, PhotoResolution.R64);

    const getUserName = () => {
      if (userInfo.firstname && userInfo.lastname) {
        return `${userInfo.firstname} ${userInfo.lastname}`;
      }
      return userInfo.firstname || userInfo.lastname || trans('UNKNOWNUSER');
    };

    const removeMemberHandler = (useruuid, memberName) => {
      setRemoveMemberUuid(useruuid);
      setRemoveMemberName(memberName);
      setShowRemoveMemberConfirmModal(true);
    };

    return (
      <div key={userItem.useruuid} className="group-member-card">
        <div className="group-member-info">
          <div className="user-image-container group-member-image-container">
            <Avatar
              size={60}
              src={profileImageUrl}
              icon={<UserOutlined />}
              className="group-member-avatar"
            />
          </div>
          <div className="group-member-name">{getUserName()}</div>
        </div>

        <div className="group-member-close">
          <div className="device-icon-container">
            {showDevice(userItem) ? (
              userItem?.userInfo?.deviceuuid !== null ? (
                <NewHC200Icon
                  style={{ backgroundColor: '#ccdce4' }}
                  status={
                    userItem?.userInfo?.deviceconnectstatus?.toLowerCase() === 'connected'
                      ? 'connected'
                      : 'disconnected'
                  }
                />
              ) : (
                <UnassignedHS200DeviceIcon />
              )
            ) : null}
          </div>

          {isStaffAdmin ? (
            <div
              className="closeIcon"
              onClick={() => {
                removeMemberHandler(userItem.useruuid, getUserName());
              }}
            >
              <CloseIcon width={20} height={20} />
            </div>
          ) : null}
        </div>
      </div>
    );
  };

  return (
    <>
      <Spin spinning={loading}>
        <div
          className="group-member-container"
          style={{ height: setupBanner ? 'calc(100vh - 439px)' : 'calc(100vh - 280px)' }}
        >
          <div className="group-member-row top">
            <span className="group-member-title">
              {trans('GROUPMEMBERS')} ({sortedStaffUsers?.length + sortedAccountUsers?.length})
            </span>
          </div>
          <div className={`group-member-list-container ${setupBanner ? 'with-banner' : ''}`}>
            <div className="group-member-list-item">
              {sortedStaffUsers?.length > 0 && (
                <div className="group-member-staff">
                  <div className="group-member-staff-header">
                    <BadgeIcon className="new-ui-icon" />
                    <span className="group-member-staff-title">
                      {trans('STAFF')} ({sortedStaffUsers?.length})
                    </span>
                  </div>
                  {sortedStaffUsers.map(renderUserCard)}
                </div>
              )}

              {sortedAccountUsers?.length > 0 && (
                <div className="group-member-accounts">
                  <div className="group-member-accounts-header">
                    <AccountIcon className="new-ui-icon" />
                    <span className="group-member-accounts-title">
                      {trans('ACCOUNTS')} ({sortedAccountUsers?.length})
                    </span>
                  </div>
                  {sortedAccountUsers.map(renderUserCard)}
                </div>
              )}

              {sortedStaffUsers?.length === 0 && sortedAccountUsers?.length === 0 && (
                <div className="groups-list-schedule">
                  <div className="no-schedule-events-container">
                    <div className="no-schedule-events-message">
                      {trans('THEGROUPHASNOTYETBEENASSIGNEDANYMEMBERS')}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Spin>
    </>
  );
};

export default GroupMember;
